import { ErrorCode } from '@afterpaytouch/portal-api/types'

export enum IdentityErrorCode {
  Default = 'default',
  IdentityCheckGatewayError = 'default',
  DuplicateIdentity = 'duplicateIdentity',
  IdentityAlreadyVerified = 'identityAlreadyVerified',
  IdentityAlreadyRejected = 'identityAlreadyRejected',
  IdentityCheckLimitExceeded = 'default',
  IdentityCheckRejected = 'identityCheckRejected',
  IdCheckRequired = 'default',
  UnsuitabilityNotFound = 'unsuitabilityNotFound',
  UnsuitabilityExpired = 'unsuitabilityExpired',
  VerificationNotPerformed = 'default',
  ProviderError = 'default',
  DeclinedDueToCountryOrigin = 'declinedDueToCountryOrigin',
  MaxAttemptsReached = 'maxAttemptsReached',
  MaxAttemptsReachedForType = 'maxAttemptsReachedForType',
  LimitInternalError = 'limitInternalError',
  CreditCheckFailure = 'creditCheckFailure',
  UnsuitabilityDecline = 'unsuitabilityDecline',
}

// @TODO: Is this too generic?
export const identityErrors: Partial<Record<ErrorCode, IdentityErrorCode>> = {
  [ErrorCode.DuplicateIdentity]: IdentityErrorCode.DuplicateIdentity,
  [ErrorCode.IdentityCheckGatewayError]: IdentityErrorCode.IdentityCheckGatewayError,
  [ErrorCode.IdentityAlreadyVerified]: IdentityErrorCode.IdentityAlreadyVerified,
  [ErrorCode.IdentityCheckLimitExceeded]: IdentityErrorCode.IdentityCheckLimitExceeded,
  [ErrorCode.IdentityCheckRejected]: IdentityErrorCode.IdentityCheckRejected,
  [ErrorCode.IdCheckRequired]: IdentityErrorCode.IdCheckRequired,
  [ErrorCode.UnsuitabilityNotFound]: IdentityErrorCode.UnsuitabilityNotFound,
  [ErrorCode.UnsuitabilityExpired]: IdentityErrorCode.UnsuitabilityExpired,
  [ErrorCode.VerificationNotPerformed]: IdentityErrorCode.VerificationNotPerformed,
  [ErrorCode.ProviderError]: IdentityErrorCode.ProviderError,
  [ErrorCode.DeclinedDueToCountryOrigin]: IdentityErrorCode.DeclinedDueToCountryOrigin,
  [ErrorCode.MaxAttemptsReached]: IdentityErrorCode.MaxAttemptsReached,
  [ErrorCode.MaxAttemptsReachedForType]: IdentityErrorCode.MaxAttemptsReachedForType,
  [ErrorCode.UnsuitabilityDecline]: IdentityErrorCode.UnsuitabilityDecline,
  [ErrorCode.LimitInternalError]: IdentityErrorCode.LimitInternalError,
  [ErrorCode.CreditCheckFailure]: IdentityErrorCode.CreditCheckFailure,
}

// TODO: Do we need this or can PortalApiError in packages/portal-api suffice?
export interface PortalApiError {
  errorCode: ErrorCode
  errorId: string
  message: string
  httpStatusCode: number
  errorInfo: any
}
